import { render, staticRenderFns } from "./StageMian.vue?vue&type=template&id=b571c75a&scoped=true"
import script from "./StageMian.vue?vue&type=script&lang=js"
export * from "./StageMian.vue?vue&type=script&lang=js"
import style0 from "./StageMian.vue?vue&type=style&index=0&id=b571c75a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b571c75a",
  null
  
)

export default component.exports